var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"about"}},[_c('p',{staticClass:"title"},[_vm._v("About")]),(_vm.about.body)?_c('vue-markdown-it',{staticClass:"content",attrs:{"source":_vm.about.body}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }